var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("background-image")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-file-upload", {
                    attrs: { label: _vm.$ct("upload"), sending: _vm.sending },
                    on: {
                      input: function ($event) {
                        return _vm.onFileInput($event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-row",
                    { attrs: { "no-margin": "" } },
                    [
                      _c("w-select", {
                        style: { flexGrow: 1 },
                        attrs: {
                          label: _vm.$ct("background-image"),
                          items: _vm.imageItems,
                          fancy: "",
                        },
                        model: {
                          value: _vm.value.BackgroundImage,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "BackgroundImage", $$v)
                          },
                          expression: "value.BackgroundImage",
                        },
                      }),
                      _c(
                        "w-button",
                        {
                          attrs: { flat: "" },
                          on: {
                            click: function ($event) {
                              _vm.editSettings = true
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "cog" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.editSettings
        ? _c(
            "w-modal",
            { attrs: { value: _vm.value != null } },
            [
              _c("page-settings-background-image-settings", {
                attrs: { value: _vm.value },
                on: {
                  close: function ($event) {
                    _vm.editSettings = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }